import { useEffect, useState } from 'react';
import './UploadContent.scss';
import UploadTypeSelector from './UploadTypeSelector';
import { useDispatch, useSelector } from 'react-redux';
import { assetType } from 'actions/assetTypes';
import Loading from 'components/Placeholders/Loading';
import { isEmpty } from 'lodash-es';
import SingleUploadMain from '../SingleUpload/SingleUploadMain';
import AssetTypeSelector from './AssetTypeSelector';
import BulkUploadMain from '../BulkUploadV2/BulkUploadMain';
import BulkUploadInfo from '../BulkUploadV2/BulkUploadInfo';


const UploadContainer = () => {
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [asstType, setAssetType] = useState({
    value: '',
    label: ''
  });
  const assetTypes = useSelector(
    (state: any) => state.assetTypeReducer?.assetTypes
  );
  const assetTypeKey = Object.keys(assetTypes?.metadata_collection || {}).find(
    (key) => {
      const typedValue = assetTypes?.metadata_collection[key] as {
        name: string;
      }; // Explicitly cast value to the expected type
      return typedValue.name === asstType.label;
    }
  );
  const defaults =
    assetTypeKey !== undefined
      ? assetTypes?.metadata_collection?.MODEL_DEFAULTS?.[assetTypeKey] || {}
      : {};

  const assetTypeLoading = useSelector(
    (state: any) => state.assetTypeReducer?.loading
  );
  const errorAssetType = useSelector(
    (state: any) => state.assetTypeReducer?.error
  );
  const dispatch = useDispatch();
  // fetch names from the object as label and values from the object as value dropdown options
  const assetTypesDropdown =
    !assetTypeLoading && !errorAssetType && !isEmpty(assetTypes)
      ? Object.entries(assetTypes?.metadata_collection)?.map(([, value]) => {
        const typedValue = value as { name: string }; // Explicitly cast value to the expected type
        return {
          label: typedValue.name,
          value: typedValue.name
        };
      })
      : [assetTypes, assetTypeLoading, errorAssetType];


  useEffect(() => {
    const fetchAssetTypes = async () => {
      try {
        await dispatch<any>(assetType.fetchAssetTypes());
      } catch (error) {
        console.error('Error fetching asset types:', error);
      }
    };
    if (!assetTypes || isEmpty(assetTypes)) {
      fetchAssetTypes();
    }
  }, []);

  //Dummy data for asset types
 

  return (
    <div className="upload-container">
      <UploadTypeSelector
        isBulkUpload={isBulkUpload}
        setIsBulkUpload={setIsBulkUpload}
      />
      <div className="upload-content">
        {isBulkUpload ? (
          <div>
            <div className="bulk-upload-header-section">
              <div className="asset-type-section">
                <AssetTypeSelector
                  asstType={asstType}
                  setAssetType={setAssetType}
                  isBulkUpload={isBulkUpload}
                />
              </div>
              <div className="bulk-upload-info-section">
                <BulkUploadInfo defaults={defaults} />
              </div>
            </div>
            <BulkUploadMain defaults={defaults} assetType={asstType.label} setAssetType={setAssetType} />
          </div>
        ) : (
          <div
            className="single-upload-content"
            style={{ marginBottom: '73px' }}>
            <SingleUploadMain />
          </div>
        )}
      </div>
      {assetTypeLoading && <Loading />}
    </div>
  );
};

export default UploadContainer;
